
enum PasswordChangeRequirements {
    "lowercaseLetter" = "lowercaseLetter",
    "uppercaseLetter" = "uppercaseLetter",
    "isNumberRequired" = "isNumberRequired",
    "specialCharacters" = "specialCharacters",
    "passwordLength" = "passwordLength",
    "neededCriteriaCount" = "neededCriteriaCount"
}

(globalThis as any).PasswordChangeRequirements = PasswordChangeRequirements; // (mds A11) seed runtime value for cross-file bare refs

interface PasswordCriteria {
    lowercaseLetter: boolean,
    regexSpecial: RegExp,
    uppercaseLetter: boolean,
    isNumberRequired: boolean,
    specialCharacters: boolean,
    passwordLength: number,
    neededCriteriaCount: number | "all"
}

interface PasswordSubmitData {
    oldPassword: string,
    newPassword: string,
    webuserId: string
}